import { connect } from 'react-redux'
import TackConfirmationComponent from '../components/tack_confirmation';


const mapStateToProps = (state, ownProps) => {
  return {
    user: state.default.user,
    tack: state.default.tack,
    word: state.default.word,
    navigation: state.default.navigation,
    params: ownProps.match.params
  }
}

export default connect(mapStateToProps)(TackConfirmationComponent);



// WEBPACK FOOTER //
// ./src/containers/tack_confirmation.js